import { useEffect, useState } from 'react';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { asyncGetParams } from '../../../../../services/param.service';
import { ParamEnum } from '../../../../../shared/types/shared';
import { PqrTypeListActions } from './actions';
import { DateTooltip } from '../../../../components/general/dateTooltip';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Param } from '../../../../../shared/types/param';

export const usePqrTypeList = (filters?: Param) => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<Param[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [finalFilters, setFinalFilters] = useState<Param | object>({});

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<Param>[] = [];

    if (!isOnlyViewProfile(type)) {
        columns.push({
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <PqrTypeListActions id={row.row.id || ''} />,
        });
    }

    columns.push(
        {
            field: 'name',
            headerName: 'Nombre',
            minWidth: 150,
            flex: 0.5,
        },
        {
            field: 'active',
            headerName: 'Activo',
            minWidth: 80,
            flex: 0.4,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <>{row.row.active ? 'Si' : 'No'}</>,
        },
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.6,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <DateTooltip date={row.row.created_at} />,
        },
        {
            field: 'updated_at',
            headerName: 'Fecha última modificación',
            minWidth: 120,
            flex: 0.6,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <DateTooltip date={row.row?.updated_at} />,
        },
        {
            field: 'updatedBy',
            headerName: 'Última modificación por',
            minWidth: 120,
            flex: 0.6,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => (
                <>{`${row.row?.updatedBy?.name ?? ''} ${
                    row.row?.updatedBy?.surname ?? ''
                }`}</>
            ),
        }
    );

    useEffect(() => {
        setPage(0);
        setFinalFilters(filters || {});
    }, [filters]);

    useEffect(() => {
        setLoading(true);
        let name: string | undefined;
        let active: boolean | undefined;

        if (
            finalFilters &&
            'name' in finalFilters &&
            'active' in finalFilters
        ) {
            ({ name, active } = finalFilters as {
                name?: string;
                active?: boolean;
            });
        }

        asyncGetParams(
            ParamEnum.PQR_TYPE,
            '',
            '',
            name,
            '',
            active,
            page,
            pageSize
        )
            .then((res: any) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, finalFilters]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
